import { render, staticRenderFns } from "./kw_menu_lable.vue?vue&type=template&id=6cb99a61&scoped=true&"
import script from "./kw_menu_lable.vue?vue&type=script&lang=js&"
export * from "./kw_menu_lable.vue?vue&type=script&lang=js&"
import style0 from "./kw_menu_lable.vue?vue&type=style&index=0&id=6cb99a61&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb99a61",
  null
  
)

component.options.__file = "kw_menu_lable.vue"
export default component.exports